import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Initialize Foundation Reveal if it hasn't been already
    if (!$(this.element).data("zfPlugin")) {
      $(this.element).foundation();
    }
  }

  open() {
    $(this.element).foundation("open");
  }

  close() {
    $(this.element).foundation("close");
  }

  // Called when the turbo-frame inside the modal finishes loading
  frameLoaded(event) {
    if (event.target.id === "modal" && event.target.getAttribute("src")) {
      this.open();
    }
  }

  // Called after a successful form submission
  submitEnd(event) {
    if (event.detail.success) {
      this.close();
    }
  }

  // Clean up the frame content when the modal is closed
  modalClosed() {
    const frame = this.element.querySelector("#modal");
    if (frame) {
      frame.innerHTML = "";
      frame.removeAttribute("src");
    }
  }
}
